module.exports = __webpack_public_path__ + "static/media/Analytics.8d3065e9.svg";